import { Injectable } from '@angular/core';

import { BetslipDisplayMode } from '@frontend/sports/types/components/bet-placement';

import { IBetslipState } from '../../../../../base/store/state';
import { BetslipType } from '../../../../../core/betslip-type';
import { BetslipGeneratorContextType, IFullBetslip, ITypeBetslip } from '../../../../bet-generation/models';
import { BetslipGeneratorInputBuilder } from '../../../../bet-generation/services/betslip-generator-input-builder.service';
import { BetslipGeneratorService } from '../../../../bet-generation/services/betslip-generator.service';
import { getLinearBetslipActiveTypes } from '../../../../types/services/betslip-types.utils';

@Injectable()
export class ValidationSlipGeneratorService {
    constructor(
        private calculatorInputBuilder: BetslipGeneratorInputBuilder,
        private calculator: BetslipGeneratorService,
    ) {}

    getBetslip(state: IBetslipState): IFullBetslip {
        const selectedType = state.types.base.currentSelectedType;
        const isLinear = state.base.displayMode === BetslipDisplayMode.Linear;

        const activeTypes =
            isLinear && selectedType !== BetslipType.EditBet ? getLinearBetslipActiveTypes(state.types.base) : selectedType ? [selectedType] : [];

        const typeBetslips = activeTypes.reduce(
            (acc, type) => {
                const input = this.calculatorInputBuilder.getCalculatorInputForType(state, type);
                const restrictions = this.calculatorInputBuilder.getRestrictionsForType(BetslipGeneratorContextType.Betslip, state, type);

                acc[type] = {
                    type,
                    slips: this.calculator.calculate(input, {
                        restrictions,
                    }).slips,
                };

                return acc;
            },
            {} as Partial<Record<BetslipType, ITypeBetslip>>,
        );

        return {
            typeBetslips,
        };
    }
}
